<script>
import axios from "axios";
import { onMounted, ref, onUpdated, toRefs, watch } from "vue";
// import "../assets/styles/theme.css";
// import "../assets/styles/form-floating.css";
import createUID from "create-unique-id";
import { useReCaptcha } from "vue-recaptcha-v3";
import { firstToLowerCase, toCamel, noSpecialCharacters } from "./helpers";

const appComponent = {
  name: "FetchForm",
  props: {
    fid: String,
    form_type: String, // "marketo" or "hubspot" or "marketo_aap"
    tyurl: String,
    tymsg: String,
    item_brand: String,
    item_category: String,
    is_modal: String,
    is_demo_modal: String,
    is_gate: String,
    layout_type: String,
    prefill_toggle_off: String,
    country_prefill: String,
    product: String,
    product_prefill: String,
  },
  setup(props) {
    const form = ref(null);
    const formFields = ref([]);
    const finalFieldsArray = ref([]);
    const fieldConditions = ref([]);
    const currentFormId = ref("");
    const thankyouMesssage = ref("Thank you");
    const thankyouUrl = ref("");
    const user_hash = ref("");
    const brand = ref("");
    const promotionName = ref("");
    const promotionID = ref("");
    const category = ref("");
    const formType = ref("");
    const modal = ref("");
    const gate = ref("");
    const MarketoProdCheck = ref(true);
    const singleLine = ref("");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pccUTM = ref(urlParams.get("pcc_utm"));
    const utmContent = ref(urlParams.get("utm_content"));
    const utmCampaign = ref(urlParams.get("utm_campaign"));
    const utmMedium = ref(urlParams.get("utm_medium"));
    const utmSource = ref(urlParams.get("utm_source"));
    const pccUTMStripped = ref("");
    const formAPIType = ref(""); // "marketo" or "hubspot" or "marketo_aap"
    const apiUrl = ref(process.env.VUE_APP_BASE_URL);
    const hiddenValues = ref({});
    const isDoubleColumn = ref();
    const isDemoModal = toRefs(props).is_demo_modal;
    const leadForm = ref(false);
    const leadFName = ref("");
    const wpdata = ref(null);
    const Loading = ref(false);
    const error = ref(null);
    const validationErrors = ref([]);
    const prefillToggleOff = ref("");
    const countryPrefill = ref("");
    const productPrefill = ref("");
    const dlProduct = ref("");
    const marketoInstance = ref("snc") // aap or snc
    const userIp = ref("");

    const formHeight = ref(0);    

    let isSubmitting = ref(false);
    let recaptchaError = ref(false);
    let honeypotError = ref(false);
    let honeypotField = ref(""); // Client-side only honeypot field
    let isSubmitted = ref(false);
    let receiptToken = ref(createUID(8));
    let isCaptchaValidated = ref(false);
    let showStateList = ref(false);

    var cartCheck = true;
    var checkoutCheck = true;
    var contentType = ref(false);

    if(/\/industry-solutions\/.+\/.+/.test(window.location.href)) {
      contentType.value = "Solution";
    }

    if(/\/products\/.+/.test(window.location.href)) {
      contentType.value = "Product";
    }
    
    // if(/\/services\/.+/.test(window.location.href)) {
    //   contentType = "Service";
    // }    

    // props.changeForm();
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    const recaptcha = async () => {
      // (optional) Wait until recaptcha has been loaded.
      await recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await executeRecaptcha("login");
      // console.log(`Recieved reCaptcha Token: ...${token.slice(-5)}`);

      let recaptchaData = "";
      
      await axios
        .post("https://" + window.location.hostname +"/wp-admin/admin-ajax.php?action=validate_google_recaptcha&token=" + token + "&source=decoupled")
        .then((res) => {       
          if (res.data.success === true) {
            recaptchaData =  res.data;
          } else {
            recaptchaData =  false;
          }
          
      })
    
      return recaptchaData
    };

    const checkUrlParams = () => {
      //UTM session storage logic
      if (
        window.location.hostname === "pcccorpdev.wpengine.com" ||
        window.location.hostname === "localhost"
      ) {
        MarketoProdCheck.value = false;
      }

      if (
        urlParams.get("utm_campaign") != null ||
        sessionStorage.getItem("utmcampaign") != null
      ) {
        if (urlParams.get("utm_campaign") != null) {
          sessionStorage.setItem("utmcampaign", urlParams.get("utm_campaign"));
        }

        formFields.value.utm_campaign__c = sessionStorage.getItem("utmcampaign");
      }

      if (
        urlParams.get("utm_medium") != null ||
        sessionStorage.getItem("utmmedium") != null
      ) {
        if (urlParams.get("utm_medium") != null) {
          sessionStorage.setItem("utmmedium", urlParams.get("utm_medium"));
        }

        formFields.value.utm_medium__c = sessionStorage.getItem("utmmedium");
      }

      if (
        urlParams.get("utm_source") != null ||
        sessionStorage.getItem("utmsource") != null
      ) {
        if (urlParams.get("utm_source") != null) {
          sessionStorage.setItem("utmsource", urlParams.get("utm_source"));
        }

        formFields.value.utm_source__c = sessionStorage.getItem("utmsource");
      }

      if (
        urlParams.get("utm_content") != null ||
        sessionStorage.getItem("utmcontent") != null
      ) {
        if (urlParams.get("utm_content") != null) {
          sessionStorage.setItem("utmcontent", urlParams.get("utm_content"));
        }

        formFields.value.utm_content__c = sessionStorage.getItem("utmcontent");
      }

      if (
        urlParams.get("utm_term") != null ||
        sessionStorage.getItem("utmterm") != null
      ) {
        if (urlParams.get("utm_term") != null) {
          sessionStorage.setItem("utmterm", urlParams.get("utm_term"));
        }

        formFields.value.utmterm = sessionStorage.getItem("utmterm");
      }

      if (
        urlParams.get("utm_adgroup") != null ||
        sessionStorage.getItem("utmadgroup") != null
      ) {
        if (urlParams.get("utm_adgroup") != null) {
          sessionStorage.setItem("utmadgroup", urlParams.get("utm_adgroup"));
        }

        formFields.value.utmadgroup = sessionStorage.getItem("utmadgroup");
      }

      // Persist GCLID 
      if (
        urlParams.get("gclid") != null ||
        sessionStorage.getItem("gclid") != null
      ) {
        if (urlParams.get("gclid") != null) {
          sessionStorage.setItem("gclid", urlParams.get("gclid"));
        }

      }
    };

    const getGTMCookie = (name) => {
      let cookies = document.cookie.split(";"),
        toReturn;
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(name + "=") === 0) {
          toReturn = cookie.substring((name + "=").length, cookie.length);
        }
      }
      return toReturn;
    };

    const visibilityConditionsCheckHubspot = (form) => {
      // console.log("visibility conditions check - hubspot edition");
      form.value.forEach((element) => {
        if (element.dataType === "hidden") {
          element.conditionalShow = false;
        } else {
          element.conditionalShow = true;
        }
      });
    };

    //Sets given cookie name and value for given amount of days
    const setExtendedTimeCookie = (cname, cvalue, exdays) => {      
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie =
        cname + "=" + cvalue + ";" + expires + ";path=/; Domain=." + window.location.hostname + "; secure";
    };

    checkUrlParams();

    if (props) {
      // console.log("all props");
      // console.log(props);

      const allProps = toRefs(props);

      if (allProps.fid.value) {
        currentFormId.value = allProps.fid.value;
        // console.log(currentFormId.value);
      }
      if (allProps.form_type.value) {
        if (allProps.form_type.value === "marketo_aap") {
          formAPIType.value = "marketo";
          marketoInstance.value = "aap";
        } 
        else {
          formAPIType.value = allProps.form_type.value;
          marketoInstance.value = "snc";
        }
        // console.log(formAPIType.value);
      }
      if (allProps.tymsg.value) {
        thankyouMesssage.value = allProps.tymsg.value;
        // console.log(thankyouMesssage.value);
      }
      if (allProps.tyurl.value) {
        thankyouUrl.value = allProps.tyurl.value;
        // console.log(thankyouUrl.value);
      }

      if (allProps.item_brand.value) {
        brand.value = allProps.item_brand.value;
        // console.log(brand.value);
      }

      if (allProps.item_category.value) {
        category.value = allProps.item_category.value;
        // console.log(category.value);
      }

      if (allProps.is_modal.value) {
        modal.value = allProps.is_modal.value === "true";
        // console.log(modal.value);
      }

      // if (allProps.is_demo_modal.value) {
      //   isDemoModal.value = allProps.is_demo_modal.value;
      //   console.log(isDemoModal.value);
      // }

      if (allProps.is_gate.value) {
        gate.value = allProps.is_gate.value === "true";
        // console.log(gate.value);
      }

      if (allProps.layout_type.value) {
        switch (allProps.layout_type.value) {
          case "double_column":
            isDoubleColumn.value = true;
            break;
          case "single_line":
            singleLine.value = true;
            break;
        }
      }

      if (allProps.prefill_toggle_off.value) {
        prefillToggleOff.value = allProps.prefill_toggle_off.value === "true";
      }

      if (allProps.product_prefill.value) {
        productPrefill.value = allProps.product_prefill.value;
      } 
      
      if (allProps.country_prefill.value) {
        countryPrefill.value = allProps.country_prefill.value.replace('"',"");
      } 
      
      if (allProps.product.value && allProps.product.value != "All") {        
        dlProduct.value = allProps.product.value;
      }   
    }

    ///// GA tracking functions
    const getGAcid = () => {
      try {
        if (window.ga) {
          // console.log("window.ga");
          var tracker = window.ga.getAll()[0];
          return tracker.get("clientId");
        }
      } catch (e) {
        return "n/a";
      }
    };


    //Sets a temporary cookie with a unique token for a purchase receipt to to redirect the Thank you page when expired.
    const setPccShortTokenCookie = (cname, cvalue) => {
      var d = new Date();
      d.setTime(d.getTime() + 20 * 1000);
      var expires = "expires=" + d.toUTCString();

      document.cookie =
        cname + "=" + cvalue + ";" + expires + ";path=/; secure";
    };

    function notYouFormSwitch() {
      leadForm.value = false;
      isSubmitting.value = false;
      honeypotError.value = false;
      formFields.value["email"] = "";
      formFields.value[
        formAPIType.value === "hubspot" ? "firstname" : "firstName"
      ] = "";
      formFields.value[
        formAPIType.value === "hubspot" ? "lastname" : "lastName"
      ] = "";
      formFields.value["company"] = "";
    }

    const getFields = async () => {      
      let actionName = "";
      switch (formAPIType.value) {
        case "hubspot":
          actionName = "hubspot_fieldlist&mkto_formid=" + currentFormId.value;
          break;
        case "marketo":
          actionName = "marketo_feildlist&mkto_formid=" + currentFormId.value;
          break;
      }

      const cachedForm = sessionStorage.getItem(
        formAPIType.value + "_form_id_" + currentFormId.value
      );

      if (cachedForm) {
        // console.log("Cached Form");
        const formData = JSON.parse(cachedForm);

        form.value = parseFields(formData);

        form.value.forEach((element) => {
          if (element.id == "Client_ID__c_contact") {
            MarketoProdCheck.value = false;
          }
        });

        if (formAPIType.value === "marketo") {
          visibilityConditionsInit();
        }

        pushDatalayer("view_item");
      } else {
        // console.log("Calling Form");

        await axios
          .get(apiUrl.value + `wp-admin/admin-ajax.php?action=${actionName}&mkto_instance=${marketoInstance.value}`)
          .then((res) => {
            // console.log("axios get");
            // a non-200 response code
            // console.log('non-200');
            // console.log(res);            

            sessionStorage.setItem(
              formAPIType.value + "_form_id_" + currentFormId.value,
              JSON.stringify(res.data)
            );

            return res.data;
          })
          .then((data) => {
            // console.log("parsing fields...");

            // set the response data
            const formData = data;

            form.value = parseFields(formData);

            // console.log("form.value");
            // console.log(form.value);

            form.value.forEach((element) => {
              if (element.id == "Client_ID__c_contact") {
                MarketoProdCheck.value = false;
              }
            });

            if (formAPIType.value === "marketo") {
              visibilityConditionsInit();
            }

            pushDatalayer("view_item");
          });
      }
    };

    const getIpAddress = async () => {
      let ipError = false;
      let ipData = "";

      await axios
        .get(`https://api.ipify.org?format=json`)
        .then((res) => {
          ipData = res.data.ip;
        })
        .catch((error) => {
          ipError = true;
          console.error("IP Error", error);
        });

      if (ipData && !ipError) {
        return ipData;
      } else {
        return false;
      }
    };

    const zoomInfoSetup = async () => {
      // console.log("zoominfo start");

      // console.log("grabbing IP");
      let ipError = false;
      
      const response = await axios.get(`https://api.ipify.org?format=json`)
      .catch(function (error) {
        // console.log("error caught, flag set")
        ipError = true;

        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
        }
        // console.log(error.config);
      });

      // console.log("IPify response");
      // console.log(response);

      // console.log("ipError");
      // console.log(ipError);

      if (response.data.ip.length != 0 && !ipError) {
        // console.log("Ip Grabbed: " + response.data.ip);
        if(getGTMCookie("zoominfo_ip") != response.data.ip){
          // console.log("New IP, setting cookie");
          setExtendedTimeCookie("zoominfo_ip", response.data.ip, 30);

          // console.log("Starting ZoomInfo process");
          
          const zoomInfoToken = await getZoomInfoAuth();
          // console.log("Token:")
          // console.log(zoomInfoToken); 

          const zoomInfoEnrichIPData = await zoomInfoEnrichIP(zoomInfoToken, response.data.ip);
          // console.log("Enriched Data IP:")
          // console.log(zoomInfoEnrichIPData.data.result[0]);
          

          if(zoomInfoEnrichIPData.data.result[0].data.company) {
            // console.log("Confidence Score")
            // console.log(zoomInfoEnrichIPData.data.result[0].data.company.confidenceScore)
          

            if(parseFloat(zoomInfoEnrichIPData.data.result[0].data.company.confidenceScore) >= 0.7) {            
              // console.log("Confidence Score above threshold, setting cookies")
              if(Object.prototype.hasOwnProperty.call(zoomInfoEnrichIPData.data.result[0].data,"company")) {
                setExtendedTimeCookie("zoominfo_country", zoomInfoEnrichIPData.data.result[0].data.company.country, 30);
                setExtendedTimeCookie("zoominfo_state", zoomInfoEnrichIPData.data.result[0].data.company.state, 30);
                setExtendedTimeCookie("zoominfo_city", zoomInfoEnrichIPData.data.result[0].data.company.city, 30);
                setExtendedTimeCookie("zoominfo_employeeCount", zoomInfoEnrichIPData.data.result[0].data.company.employeeCount, 30);
                setExtendedTimeCookie("zoominfo_company", zoomInfoEnrichIPData.data.result[0].data.company.name, 30);
                setExtendedTimeCookie("zoominfo_company_id", zoomInfoEnrichIPData.data.result[0].data.company.id, 30);
                setExtendedTimeCookie("zoominfo_confidence_score", zoomInfoEnrichIPData.data.result[0].data.company.confidenceScore, 30);
                setExtendedTimeCookie("zoominfo_revenue", zoomInfoEnrichIPData.data.result[0].data.company.revenue, 30);
                setExtendedTimeCookie("zoominfo_street", zoomInfoEnrichIPData.data.result[0].data.company.street, 30);
                setExtendedTimeCookie("zoominfo_ticker", zoomInfoEnrichIPData.data.result[0].data.company.ticker, 30);
                setExtendedTimeCookie("zoominfo_website", zoomInfoEnrichIPData.data.result[0].data.company.website, 30);
                setExtendedTimeCookie("zoominfo_zipCode", zoomInfoEnrichIPData.data.result[0].data.company.zipCode, 30);
              }
            } else {
              // console.log("Confidence Score below threshold, nothing happens")
            }
          }
          

          // if(Object.prototype.hasOwnProperty.call(zoomInfoEnrichIPData.data.result[0].data,"ispInfo")){
          //   console.log("Enriched data is an ISP")
          // }
        } else {
          // console.log("IP same as stored cookie, no zoominfo calls")
        }                                           
      }                  
    };

    //Get JWT for use in ZoomInfoApi
    const getZoomInfoAuth = async () => {        
      let actionName = "zoominfo_auth";      
      
      try {
        const response = await axios.get(apiUrl.value + `wp-admin/admin-ajax.php?action=${actionName}`);
        if (response.data.jwt.length != 0) {
          return response.data.jwt;
        } else {          
          return response;
        }
      } catch (error) {
        // console.error("ZoomInfo Auth Error", error);
      }      
    };

    const zoomInfoEnrichEmail = async (zoomInfoToken) => {                    
      let actionName = "zoominfo_email_enrich&zoominfo_token=" + encodeURIComponent(zoomInfoToken);         
      
      try {
        const response = await axios.get(apiUrl.value + `wp-admin/admin-ajax.php?action=${actionName}`);
        if (response.data != 0) {
          return response.data;
        } else {          
          return response;
        }
      } catch (error) {
        // console.error("ZoomInfo Enrich Error", error);
      }      
    };

    const zoomInfoEnrichIP = async (zoomInfoToken, zoomInfoIP) => {                    
      let actionName = "zoominfo_enrich&zoominfo_token=" + encodeURIComponent(zoomInfoToken) + "&zoominfo_ip=" + encodeURIComponent(zoomInfoIP);      
      
      try {
        const response = await axios.get(apiUrl.value + `wp-admin/admin-ajax.php?action=${actionName}`);
        if (response.data != 0) {
          return response.data;
        } else {          
          return response;
        }
      } catch (error) {
        // console.error("ZoomInfo Enrich Error", error);
      }      
    };

    // Parse the JSON input into a form fields object
    const parseFields = (formData) => {
      let formFieldsObj;

      switch (formAPIType.value) {
        case "hubspot": {
          let formName =
            // .find((item) => item.guid === currentFormId.value)
            JSON.parse(formData.body).name;

          // Get URL parameters for hidden fields
          hiddenValues.value["leadsource"] = urlParams.get("leadsource")
            ? urlParams.get("leadsource")
            : "";
          hiddenValues.value["lead_source_description__c"] =
            urlParams.get("lead_source_description__c") ??
            getGTMCookie("pccUTM") ??
            "";
          hiddenValues.value["page_url"] = window.location.href.split("?")[0];
          // console.log([leadSource, leadSourceDescription, currentUrl])

          // console.log(JSON.parse(formData.body));

          formFieldsObj = JSON.parse(formData.body)          
            [
              // .find((item) => item.guid === currentFormId.value)
              "formFieldGroups"
            ].map((group) => {
              // Ungroup the pairs of fields
              if (group.fields.length > 1) {
                let hasHiddenField = false;
                group.fields.forEach((field) => {
                  if (field.hidden) {
                    hasHiddenField = true;
                  }
                });
                !hasHiddenField &&
                  group.fields.forEach((field) => {
                    field.isHalfWidth = true;
                  });
              }
              // else {
              //   group.fields[0].isHalfWidth = false
              // }
              return group["fields"];
            })
            .flat()
            .map((field) => {              
              let properties = {
                isHalfWidth: field.isHalfWidth,
                id: field.name,
                label: field.label
                  ? field.label
                  : field.placeholder
                  ? field.label || field.placeholder
                  : field.unselectedLabel,
                dataType:
                  field.name === "email"
                    ? "email"
                    : field.name === "phone"
                    ? "telephone"
                    : field.fieldType === "booleancheckbox"
                    ? "checkbox"
                    : field.hidden
                    ? "hidden"
                    : field.fieldType,
                required: field.required,
                fieldMetaData: {
                  values:
                    field.options.length &&
                    field.options.map((item) => {
                      return { label: item.label, value: item.value };
                    }),
                },
                validationMessage: field.validation.message,
              };
              return properties;
            });

          // console.log("formFieldsObj");
          // console.log(formFieldsObj);
          return formFieldsObj;
        }
        case "marketo":          
          formFieldsObj = formData.result.map((field) => {
            let properties = {
              id:
                field.id === "ProductsofInterest"
                  ? field.id
                  : firstToLowerCase(field.id),
              label: field.label.endsWith(":")
                ? field.label.slice(0, -1)
                : field.label, // Remove the ':' from the end of label names
              dataType: field.dataType,
              isHalfWidth: false,
              required: field.required,
              fieldMetaData: field.fieldMetaData ? field.fieldMetaData : "",
              validationMessage: field.validationMessage,
              visibilityRules: field.visibilityRules
                ? field.visibilityRules
                : "none",
              conditionalShow: !field.visibilityRules
                ? true
                : field.visibilityRules.ruleType === "alwaysShow"
                ? true
                : false,
            };

            return properties;
          });
          // console.log("formFieldsObj");
          // console.log(formFieldsObj);
          return formFieldsObj;
      }
    };

    const prefillFields = async () => {
      const gatedArray = document.getElementsByClassName("gated-community");
      var _mkto_trk = getGTMCookie("_mkto_trk");

      if (formAPIType.value == "hubspot") {
        let hutk = getGTMCookie("hubspotutk");
        // let hutk = 'd2e988240d7bf05f27a900e2fb4940ec'
        // console.log(
        //   apiUrl.value +
        //     `wp-admin/admin-ajax.php?action=hubspot_prefill&hubspotutk=${hutk}`
        // );
        await axios
          .get(
            apiUrl.value +
              `wp-admin/admin-ajax.php?action=hubspot_prefill&hubspotutk=${hutk}`
          )
          .then((res) => {
            // console.log(res.data);

            let hubLeadBody = JSON.parse(res.data.body);
            // console.log('hubLeadBody')
            // console.log(hubLeadBody.properties)

            if (!hubLeadBody || !hubLeadBody["is-contact"]) {
              // Contact not found
              return;
            }
            // console.log('form.value')
            // console.log(form.value)
            leadForm.value = true;
            formType.value = "-preff";

            form.value.map((field) => {
              if (
                Object.prototype.hasOwnProperty.call(
                  hubLeadBody.properties,
                  field.id
                )
              ) {
                // console.log(field.id, field.required);
                formFields.value[field.id] =
                  hubLeadBody.properties[field.id].value;
              }

              if (
                field.required &&
                !Object.prototype.hasOwnProperty.call(
                  hubLeadBody.properties,
                  field.id
                )
              ) {
                // console.log(`Prefill - missing required field: ${field.id}`);
                leadForm.value = false;
              }
            });

            // console.log("formFields.value");
            // console.log(formFields.value);
          });   

          if (getGTMCookie('zoominfo_company')) {
            formFields.value["company"] = getGTMCookie('zoominfo_company');  
            formFields.value["zoominfo_company_name"] = getGTMCookie('zoominfo_company');            
          }       

          if (getGTMCookie('zoominfo_state')) {
            formFields.value["zoominfo_state"] = getGTMCookie('zoominfo_state');     
            formFields.value["state"] = getGTMCookie('zoominfo_state');            
          }       

          if (getGTMCookie('zoominfo_confidence_score')) {
            formFields.value["zoominfo_confidence_score"] = getGTMCookie('zoominfo_confidence_score');            
          }
            
          if (getGTMCookie('zoominfo_company_id')) {
            formFields.value["zoominfo_company_id"] = getGTMCookie('zoominfo_company_id');            
          }

          if (getGTMCookie('zoominfo_employeeCount')) {
            formFields.value["zoominfo_employee_count"] = getGTMCookie('zoominfo_employeeCount');            
          }

          if (getGTMCookie('zoominfo_revenue')) {
            formFields.value["zoominfo_revenue"] = getGTMCookie('zoominfo_revenue');            
          }

          if (getGTMCookie('zoominfo_ticker')) {
            formFields.value["zoominfo_ticker"] = getGTMCookie('zoominfo_ticker');            
          }

          if (getGTMCookie('zoominfo_website')) {
            formFields.value["zoominfo_website"] = getGTMCookie('zoominfo_website');            
          }

          if (getGTMCookie('zoominfo_street')) {
            formFields.value["zoominfo_street"] = getGTMCookie('zoominfo_street');            
          }

          if (getGTMCookie('zoominfo_zipCode')) {
            formFields.value["zoominfo_zipcode"] = getGTMCookie('zoominfo_zipCode');            
          }

          if (getGTMCookie('zoominfo_city')) {
            formFields.value["zoominfo_city"] = getGTMCookie('zoominfo_city');            
          }

          if (getGTMCookie('zoominfo_country')) {
            formFields.value["zoominfo_country"] = getGTMCookie('zoominfo_country');            
          }
      }

      if (formAPIType.value == "marketo") {
        if (
          _mkto_trk &&
          sessionStorage.getItem("leadCheckPerformed") === null
        ) {
          const enc_mkto_trk = encodeURIComponent(_mkto_trk);
          // console.log(
          //   apiUrl.value +
          //     `wp-admin/admin-ajax.php?action=marketo_prefill&_mkto_trk=${enc_mkto_trk}`
          // );

          await axios
            .get(
              apiUrl.value +
                `wp-admin/admin-ajax.php?action=marketo_prefill&_mkto_trk=${enc_mkto_trk}&mkto_instance=${marketoInstance.value}`
            )
            .then((res) => {
              // console.log(res);

              if (res.data.success) {
                return res.data.result[0];
              } else {
                return res.data.success;
              }
            })
            .then((data) => {
              // console.log("lead call making");
              sessionStorage.setItem("leadCheckPerformed", "true");

              if (data != false) {
                // const parsedData = JSON.parse(data).result;
                const parsedData = data;
                // console.log("parsedData");
                // console.log(parsedData);

                if (data) {
                  // console.log("lead");                  

                  if (data.email) {
                    formFields.value["email"] = data.email;

                    if (singleLine.value) {
                      isSubmitting.value = true;
                    }

                    sessionStorage.setItem("formEmail", data.email);

                    if (gate.value) {
                      //There is a lead, grant access to content
                      for (const element of gatedArray) {
                        element.classList.add("open-the-gate");
                      }
                    }
                  }

                  if (data.firstName) {
                    formType.value = "-preff";
                    formFields.value["firstName"] = data.firstName;
                    sessionStorage.setItem("formFName", data.firstName);
                  }

                  if (data.lastName) {
                    formFields.value["lastName"] = data.lastName;
                    sessionStorage.setItem("formLName", data.lastName);
                  }

                  if (data.company) {
                    formFields.value["company"] = data.company;
                    sessionStorage.setItem("formCompany", data.company);
                  }

                  if (
                    window.location.hostname === "pcccorpdev.wpengine.com" ||
                    window.location.hostname === "localhost"
                  ) {
                    if (data.Products_of_Interest__c) {
                      if(!dlProduct.value || formFields.value["Products_of_Interest__c"] === "Not Applicable" || !formFields.value["Products_of_Interest__c"]) {
                        formFields.value["Products_of_Interest__c"] = data.Products_of_Interest__c;
                      }                      
                      sessionStorage.setItem("productInterest", data.Products_of_Interest__c);
                    }
                  } else {                    
                    if (data.ProductsofInterest) {     
                      if(!dlProduct.value || formFields.value["ProductsofInterest"] === "Not Applicable" || !formFields.value["ProductsofInterest"]) {                 
                        formFields.value["ProductsofInterest"] = data.ProductsofInterest;
                      }
                      sessionStorage.setItem("productInterest", data.ProductsofInterest);
                    }
                  }
                  
                } else {
                  // console.log("no-lead");

                  if (gate.value) {
                    //No lead, keep form open
                    for (const element of gatedArray) {
                      element.classList.remove("open-the-gate");
                    }
                  }
                }
              }
            });
        } else {
          // console.log("check already performed");
          formFields.value["email"] = sessionStorage.getItem("formEmail");
          formFields.value["firstName"] = sessionStorage.getItem("formFName");
          formFields.value["lastName"] = sessionStorage.getItem("formLName");
          formFields.value["company"] = sessionStorage.getItem("formCompany");
          if (
            window.location.hostname === "pcccorpdev.wpengine.com" ||
            window.location.hostname === "localhost"
          ) {            
            if(!dlProduct.value || formFields.value["Products_of_Interest__c"] === "Not Applicable" || !formFields.value["Products_of_Interest__c"]) {              
              formFields.value["Products_of_Interest__c"] = sessionStorage.getItem("productInterest");
            }            
          } else {
            if(!dlProduct.value || formFields.value["ProductsofInterest"] === "Not Applicable" || !formFields.value["ProductsofInterest"]) {
              formFields.value["ProductsofInterest"] = sessionStorage.getItem("productInterest");
            }
          }

          if (sessionStorage.getItem("formEmail")) {
            if (singleLine.value) {
              isSubmitting.value = true;
            }

            if (sessionStorage.getItem("formFName")) {
              formType.value = "-preff";
            }
          }
        }

        if(marketoInstance.value === "aap") {
          // console.log('aap, set mkto fields')
          
          if (getGTMCookie('zoominfo_company')) {
            formFields.value["company"] = getGTMCookie('zoominfo_company');  
            formFields.value["Enriched_Name__c"] = getGTMCookie('zoominfo_company');            
          }       

          if (getGTMCookie('zoominfo_state')) {
            formFields.value["Enriched_State__c"] = getGTMCookie('zoominfo_state');     
            formFields.value["state"] = getGTMCookie('zoominfo_state');            
          }       

          if (getGTMCookie('zoominfo_confidence_score')) {
            formFields.value["Enriched_ConfidenceScore__c"] = getGTMCookie('zoominfo_confidence_score');            
          }
            
          if (getGTMCookie('zoominfo_company_id')) {
            formFields.value["Enriched_ID__c"] = getGTMCookie('zoominfo_company_id');            
          }

          if (getGTMCookie('zoominfo_employeeCount')) {
            formFields.value["Enriched_EmployeeCount__c"] = getGTMCookie('zoominfo_employeeCount');            
          }

          if (getGTMCookie('zoominfo_revenue')) {
            formFields.value["Enriched_Revenue__c"] = getGTMCookie('zoominfo_revenue');            
          }

          if (getGTMCookie('zoominfo_ticker')) {
            formFields.value["Enriched_Ticker__c"] = getGTMCookie('zoominfo_ticker');            
          }

          if (getGTMCookie('zoominfo_website')) {
            formFields.value["Enriched_Website__c"] = getGTMCookie('zoominfo_website');            
          }

          if (getGTMCookie('zoominfo_street')) {
            formFields.value["Enriched_Street__c"] = getGTMCookie('zoominfo_street');            
          }

          if (getGTMCookie('zoominfo_zipCode')) {
            formFields.value["Enriched_ZipCode__c"] = getGTMCookie('zoominfo_zipCode');            
          }

          if (getGTMCookie('zoominfo_city')) {
            formFields.value["Enriched_City__c"] = getGTMCookie('zoominfo_city');            
          }

          if (getGTMCookie('zoominfo_country')) {
            formFields.value["Enriched_Country__c"] = getGTMCookie('zoominfo_country');            
          }
        }
      }
    };

    const validateInput = async (selectedField) => {
      isSubmitting.value = false;

      //Initialzie array that will contain true/false values (true meaning there is a validation error)
      var valErrorArray = [];

      if (formAPIType.value === "marketo") {
        await visibilityConditionsCheck();
      }

      //Get fields that are on the dom
      const visibleFields = document.getElementsByClassName("visible-field");

      for (let field of form.value) {
        let shownField = false;

        //Only validate the field if it is on the dom
        for (let item of visibleFields) {
          if (item.attributes.field.value === field.id) {
            shownField = true;
          }
        }        

        if (shownField && field.required) {     
          //Validate every required input, will push true or false to the array     
          valErrorArray.push(validateSingleInput(field.id, selectedField));
        }        
      }
      
      if (honeypotField.value && honeypotField.value.trim() !== "") {
        isSubmitting.value = false;
        honeypotError.value = true;
        return;
      } else {
        honeypotError.value = false;
      }
      
      //If there are no errors (all values in array are false), enable the submit button
      if(!valErrorArray.includes(true)) {
        isSubmitting.value = true;
      }
      
      // console.log('valErrorArray');
      // console.log(valErrorArray);
    };  

    const pushCheckout = (selectedField) => {
      if (selectedField == "email") {
        pushDatalayer("begin_checkout");
      }

      if (selectedField.toLowerCase() == "firstname") {
        pushDatalayer("add_to_cart");
      }
    };

    //Funciton that will return true or false depending on if it passes validation or not (true = fails)
    const validateSingleInput = (fieldName, selectedField) => {
      // console.log("validate check");
      // console.log(`Validating imput for field {${fieldName}}`)
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const phoneRegex = /^[\d \-()]*$/;
      const websiteRegex =
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi;

      let isSelected = false;

      if (selectedField === fieldName) {
        // Check every field to see if the form can submit, but
        // only show verification message for the selected field
        isSelected = true;
      }

      // console.log(formFields.value[fieldName]);
      // console.log("formFields.value[fieldName]");

      // console.log("keyup fieldName" + fieldName);
      // console.log("keyup formFields.value" + formFields.value[fieldName]);
      //  check if required field is empty
      if (
        (formFields.value[fieldName] === "") ||
        (formFields.value[fieldName] === undefined) ||
        (formFields.value[fieldName] === null) ||
        (formFields.value[fieldName] === false)
      ) {
        isSelected && (validationErrors.value[fieldName] = "reqired");
        return true;        
      } else if (
        !emailRegex.test(formFields.value[fieldName]) &&
        fieldName === "email"
      ) {        
        isSelected && (validationErrors.value[fieldName] = "email");
        return true;        
      } else if (
        !phoneRegex.test(formFields.value[fieldName]) &&
        fieldName === "phone"
      ) {
        isSelected && (validationErrors.value[fieldName] = "phone");
        return true;
      } else if (
        !websiteRegex.test(formFields.value[fieldName]) &&
        fieldName === "website"
      ) {
        isSelected && (validationErrors.value[fieldName] = "website");
        return true;        
      } else {
        delete validationErrors.value[fieldName];
        return false;
      }     
    };

    const checkCountry = (country, index) => {
      switch (formAPIType.value) {
        case "hubspot":
          if (country === "United States") {
            return index >= 0 && index <= 62;
          }
          if (country === "Canada") {
            return index >= 63 && index <= 75;
          } else {
            return index === 76;
          }

        case "marketo":
          if (country === "United States") {
            return index >= 1 && index <= 63;
          }
          if (country === "Canada") {
            return index >= 64 && index <= 76;
          } else {
            return index === 77;
          }
      }
    };

    const pushDatalayer = (eventType) => {
      // console.log(window.location.pathname);
      // console.log(`Pushing data layer... Event type: ${eventType}`)
      if (window.dataLayer) {
        window.dataLayer = window.dataLayer || [];

        if(getGTMCookie("personalizationPromo")) {                
          promotionName.value = getGTMCookie("personalizationPromo");

          if(getGTMCookie("personalizationPromoID")) {                
            promotionID.value = getGTMCookie("personalizationPromoID");
          } else {
            promotionID.value = getGTMCookie("personalizationPromo");
          }
        }   
        
        // Transaction (successful MQL form submission)
        if (eventType === "view_item") {
          // console.log("VApp logs:");

          // if(isScriptLoaded("https://cdn.evgnet.com/beacon/pointclickcaretech/development/scripts/evergage.min.js")) {
          // console.log("beacon loaded");

          // if(Evergage) {
          //   console.log('evergage')

          //   document.addEventListener(Evergage.CustomEvents.OnTemplateDisplayEnd, (domEvent) => {
          //     console.log('evergage template end')
          //     tnsInit();
          //   });

          //   tnsInit();
          // }
          
          if (window.SalesforceInteractions) {
            // console.log("window.SalesforceInteractions");

            document.addEventListener(
              window.SalesforceInteractions.mcis.CustomEvents
                .OnTemplateDisplayEnd,
              (domEvent) => {
                // console.log("window.SalesforceInteractions template end");
                // tnsInit();
              }
            );                                                                                  

            document.addEventListener(
              window.SalesforceInteractions.mcis.CustomEvents.OnEventResponse,
              (domEvent) => {
                // console.log(domEvent.detail.campaignStat.stat); // will log "Impression" after the `sendStat` call below
                // console.log("domEvent.detail.OnEventResponse"); // will log "Impression" after the `sendStat` call below
                // console.log(domEvent.detail); // will log "Impression" after the `sendStat` call below
              }
            );                             
          }
          // }

          window.dataLayer.push({
            event: "view_item",
            formType: formType.value, // only needed for prefilled forms - if prefilled form value is'-preff'; if not prefilled form leave empty or omit
            formId: currentFormId.value,
            ecommerce: {
              items: [
                {
                  item_name: window.location.pathname.concat(formType.value), // {page path}{formType} - formType as existing dataLayer, remove??
                  item_id: window.location.pathname, // page path
                  price: "1", // static
                  item_brand: brand.value, // dL value: pageSegment
                  item_category: category.value, // dl value pageSolution
                  item_category2: isDoubleColumn.value ? '2-column' : '1-column', // form type, 1 column or 2
                  promotion_id: promotionID.value,
                  promotion_name: promotionName.value, // last internal promo clicked
                  quantity: "1",
                },
              ],
            },
          });
        } else if (eventType === "add_to_cart" && cartCheck) {
          if(contentType && window.SalesforceInteractions) {
            window.SalesforceInteractions.sendEvent({
              interaction: {
                name: "Add To Cart",
                lineItem: {
                    catalogObjectType: contentType,
                    catalogObjectId: window.SalesforceInteractions.cashDom("meta[name='post-id']").first().attr("content"),
                    quantity: 1,
                    price: 1,
                    currency: "USD"                      
                }
              }
            })
          }
          
          cartCheck = false;

          window.dataLayer.push({
            event: "add_to_cart",
            formType: formType.value, // only needed for prefilled forms - if prefilled form value is'-preff'; if not prefilled form leave empty or omit
            formId: currentFormId.value,
            ecommerce: {
              items: [
                {
                  item_name: window.location.pathname.concat(formType.value), // {page path}{formType} - formType as existing dataLayer, remove??
                  item_id: window.location.pathname, // page path
                  price: "1", // static
                  item_brand: brand.value, // dL value: pageSegment
                  item_category: category.value, // dl value pageSolution
                  item_category2: isDoubleColumn.value ? '2-column' : '1-column', // form type, 1 column or 2
                  promotion_id: promotionID.value,
                  promotion_name: promotionName.value, // last internal promo clicked
                  quantity: "1",
                },
              ],
            },
          });
        } else if (eventType === "begin_checkout" && checkoutCheck) {          
          checkoutCheck = false;

          window.dataLayer.push({
            event: "begin_checkout",
            formType: formType.value, // only needed for prefilled forms - if prefilled form value is'-preff'; if not prefilled form leave empty or omit
            formId: currentFormId.value,
            ecommerce: {
              items: [
                {
                  item_name: window.location.pathname.concat(formType.value), // {page path}{formType} - formType as existing dataLayer, remove??
                  item_id: window.location.pathname, // page path
                  price: "1", // static
                  item_brand: brand.value, // dL value: pageSegment
                  item_category: category.value, // dl value pageSolution
                  item_category2: isDoubleColumn.value ? '2-column' : '1-column', // form type, 1 column or 2
                  promotion_id: promotionID.value,
                  promotion_name: promotionName.value, // last internal promo clicked
                  quantity: "1",
                },
              ],
            },
          });
        } else if (eventType === "purchase" || eventType === "form_submit") {
          // console.log("purchase eventType email");
          // console.log(formFields.value.email);          

          // pass non PII form values to DL
          const mktoFormValues = {};
          if (formFields.value.Organization_Type__c) {
            mktoFormValues.form_values_organization_type = noSpecialCharacters(
              formFields.value.Organization_Type__c
            );
          }
          if (formFields.value.Capacity_Range__c) {
            mktoFormValues.form_values_capacity_range = noSpecialCharacters(
              formFields.value.Capacity_Range__c
            );
          }
          if (formFields.value.country) {
            mktoFormValues.form_values_country = formFields.value.country;
          }
          if (formFields.value.state) {
            mktoFormValues.form_values_state = formFields.value.state;
          }

          mktoFormValues.form_values_products_of_interest = "";

          //mk sandbox field name
          if (formFields.value.Products_of_Interest__c) {
            mktoFormValues.form_values_products_of_interest =
              noSpecialCharacters(formFields.value.Products_of_Interest__c);
          }
          //mk prod field name
          if (formFields.value.ProductsofInterest) {
            mktoFormValues.form_values_products_of_interest =
              noSpecialCharacters(formFields.value.ProductsofInterest);
          }
          // Use PCC__c for AAP forms, PCC_UTM__c for SNC forms
          if (formFields.value.PCC_UTM__c) {
            mktoFormValues.PCC_UTM__c = formFields.value.PCC_UTM__c;
          }
          if (formFields.value.PCC__c) {
            mktoFormValues.PCC__c = formFields.value.PCC__c;
          }
          if (formFields.value.email) {            
            mktoFormValues.form_values_email = formFields.value.email;
          }
          // if (currentFormId.value) {
          //   mktoFormValues.mkto.form.values.formid = currentFormId.value;
          // }
          // console.log("mktoFormValues");
          // console.log(mktoFormValues);

          if(eventType === "purchase") {                 
            window.dataLayer.push({
              event: "purchase",
              formType: formType.value, // only needed for prefilled forms - if prefilled form value is'-preff'; if not prefilled form leave empty or omit
              currency: "USD",
              formID: currentFormId.value,
              user_hash: user_hash.value,       
              product_interest: mktoFormValues.form_values_products_of_interest,       
              ...mktoFormValues,
              ecommerce: {
                value: 1,
                transaction_id: receiptToken.value, // value from pcc_form_receipt cookie (existing)
                items: [
                  {
                    item_name: window.location.pathname.concat(formType.value), // {page path}{formType} - formType as existing dataLayer, remove??
                    item_id: window.location.pathname, // page path
                    price: "1", // static
                    item_brand: brand.value, // dL value: pageSegment
                    item_category: category.value, // dl value pageSolution
                    item_category2: isDoubleColumn.value ? '2-column' : '1-column', // form type, 1 column or 2
                    item_category3: mktoFormValues.form_values_products_of_interest,
                    item_variant: (formAPIType.value === "marketo" & marketoInstance.value === "snc") ? "SC" : "AP",
                    promotion_id: promotionID.value,
                    promotion_name: promotionName.value, // last internal promo clicked
                    quantity: "1",
                  },
                ],
              },
            });
          } else if (eventType === "form_submit") {
            window.dataLayer.push({
              event: "form_submit",
              formType: formType.value, // only needed for prefilled forms - if prefilled form value is'-preff'; if not prefilled form leave empty or omit
              currency: "USD",
              formID: currentFormId.value,
              user_hash: user_hash.value,
              ...mktoFormValues,              
            });
          }
          
        } else if (eventType === "trackModalSubmission") {
          // for form in a modal
          window.dataLayer.push({
            event: "trackEvent",
            eventCategory: "Website Form Submissions", // static
            eventAction: "Contact Us", // static
            eventLabel: "Modal", //  static
            formId: currentFormId.value,
          });
        }

        //Purchase event for SF only
        if(eventType === "purchase") {
          if(contentType && window.SalesforceInteractions) {
            window.SalesforceInteractions.sendEvent({
              interaction: {
                    name: 'Purchase',
                    order: {
                        id: window.SalesforceInteractions.cashDom("meta[name='post-id']").first().attr("content") + "-" + window.SalesforceInteractions.getAnonymousId(),
                        totalValue: 1,
                        currency: "USD",
                        lineItems: [{
                            catalogObjectType: contentType,
                            catalogObjectId: window.SalesforceInteractions.cashDom("meta[name='post-id']").first().attr("content"),
                            quantity: 1,
                            price: 1,
                        }]
                    }
                }
            })                    
          }

          if(formFields.value.email && window.SalesforceInteractions) {
              window.SalesforceInteractions.sendEvent({
              user: {                  
                  attributes: {                      
                      email: formFields.value.email
                  }
              }
            })
          }    
        }
      }
      // console.log("pushDatalayer: " + eventType);
    };

    //Run onces on load to convert condition subject field from label to id
    const visibilityConditionsInit = () => {
      form.value.forEach((element) => {
        if (element.visibilityRules != "none") {
          if (element.visibilityRules.ruleType != "alwaysShow") {
            element.visibilityRules.rules.forEach((rule) => {
              const subjectField = rule.subjectField;

              form.value.forEach((innerElement) => {
                if (subjectField === innerElement.label) {
                  rule.subjectField = innerElement.id;
                }
              });
            });
          }
        }
      });

      visibilityConditionsCheck();
    };

    //Function to programatically check the field conditions and update field visibility
    const visibilityConditionsCheck = () => {
      // console.log("visibility conditions check");

      form.value.forEach((element) => {
        if (element.visibilityRules != "none") {
          if (element.visibilityRules.ruleType != "alwaysShow") {
            element.conditionalShow = false;

            element.visibilityRules.rules.forEach((rule) => {
              switch (rule.operator) {
                case "is":
                  rule.values.forEach((conditionalValue) => {
                    if (
                      conditionalValue === formFields.value[rule.subjectField]
                    ) {
                      element.conditionalShow = true;
                    }
                  });
                  break;
              }
            });
          }
        }
      });
    };

    // API call to WP/MK
    const submitData = (mkLeadFormBody) => {
      let actionName;
      let submitBody;
      Loading.value = true;
      switch (formAPIType.value) {
        case "hubspot":
          actionName = `hubspot_submit_form&mkto_formid=${currentFormId.value}`;
          submitBody = JSON.stringify(mkLeadFormBody);
          break;
        case "marketo":
          actionName = "marketo_submit_form_vue";
          submitBody = JSON.stringify(mkLeadFormBody);          
          break;
      }
      return fetch(
        apiUrl.value + `wp-admin/admin-ajax.php?action=${actionName}&mkto_instance=${marketoInstance.value}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: submitBody,
        }
      )
        .then((res) => {
          // console.log("submit res HTTP");
          // console.log(`submitting form: ${currentFormId.value}`);
          // console.log(res);

          // a non-200 response code
          if (!res.ok) {
            // create error instance with HTTP status text
            const error = new Error(res.statusText);
            error.json = res.json();
            console.log(error);
            throw error;
          }

          return res.json();
        })
        .then((json) => {
          // set the response data
          wpdata.value = json;
          // console.log(json);
          isSubmitted.value = true;
          pushDatalayer("form_submit");
          pushDatalayer("purchase");

          if (modal.value) {
            pushDatalayer("trackModalSubmission");
          }

          if (thankyouUrl.value) {
            window.location.href = thankyouUrl.value;
          }
        })
        .catch((err) => {
          error.value = err;
          // In case a custom JSON error response was provided
          if (err.json) {
            return err.json.then((json) => {
              // set the JSON response message
              error.value.message = json.message;
              console.log(error);
            });
          }
        })
        .then(() => {
          // console.log("Loading false");
          Loading.value = false;
        });
    }

    const onSubmit = async () => {      
      // If honeypot field has a value, prevent form submitting
      if (honeypotField.value && honeypotField.value.trim() !== "") {
        // console.log("Honeypot field filled - submission blocked");
        honeypotError.value = true;
        return;
      }
      honeypotError.value = false;

      let recaptchaData = await recaptcha();

      if(recaptchaData) {
        if (recaptchaData.score >= 0.8 && recaptchaData.success === true) {          
          const multiChecks = document.getElementsByClassName("multi-check-input");

          //Multicheck value logic
          if (multiChecks) {
            for (let element of multiChecks) {
              if (element.checked) {
                var checkboxField = element.getAttribute("checkboxes");

                if (!formFields.value[checkboxField]) {
                  formFields.value[checkboxField] = element.getAttribute("value");
                } else {
                  formFields.value[checkboxField] = formFields.value[
                    checkboxField
                  ].concat(", " + element.getAttribute("value"));
                }
              }
            }
          }

          // console.log(sessionStorage.getItem("leadCheckPerformed"));
          sessionStorage.removeItem("leadCheckPerformed");
          // console.log(sessionStorage.getItem("leadCheckPerformed"));

          if (gate.value) {
            const gatedArray = document.getElementsByClassName("gated-community");

            for (const element of gatedArray) {
              element.classList.add("open-the-gate");
            }
          }

          var hashHex = "";

          if (formFields.value.email) {
            const emailValue = formFields.value.email;

            //SHA-256 Encoding the email
            const encoder = new TextEncoder();
            const view = encoder.encode(emailValue);
            const digest = await window.crypto.subtle.digest("SHA-256", view);

            const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
            hashHex = hashArray
              .map((b) => b.toString(16).padStart(2, "0"))
              .join(""); // convert bytes to hex string

            // console.log("Hashed Email:");
            // console.log(hashHex);

            user_hash.value = hashHex;

            setExtendedTimeCookie("heUID", hashHex, 30);
          }

          //Array containing all the field ids that exist in the form
          const formFieldIDs = [];

          //Add field ids to the array
          for (var x in form.value) {
            formFieldIDs.push(form.value[x].id);
          }

          //Setting hidden fields outside of marketo body to consolidate fields into 1 array
          if (formAPIType.value === "marketo") {
            // PCC__c for A&P forms, PCC_UTM__c for SNC forms
            if (marketoInstance.value === "aap") {
              formFields.value.PCC__c = getGTMCookie("pccCookie");
            } else {
              formFields.value.PCC_UTM__c = getGTMCookie("pccCookie");
            }
            formFields.value.PCC_GCID__c = getGAcid();
            formFields.value.SF_Campaign_Name__c = getGTMCookie("pccUTM");
            formFields.value.GA4_CID__c = getGTMCookie("_ga_NBXHRQDSJE") || "";
            formFields.value.Tracking_ID__c = "G-NBXHRQDSJE"; // SNC GA Measurement ID - NOT tracking ID
            formFields.value.Transaction_ID__c = receiptToken.value;
            formFields.value.HE_UID__c = hashHex;

            if (marketoInstance.value === "aap") {
              // Page submitted url - without query string
              formFields.value.Product_Page_of_Interest__c = window.location.href.split("?")[0]; 
            }

            // Set GCLID from sessionStorage if available
            if (sessionStorage.getItem("gclid")) {
              formFields.value.GCLID__c = sessionStorage.getItem("gclid");
            }

            //Prod check due to different field ids based on environment
            if (MarketoProdCheck.value) {
              formFields.value.Client_ID__c = getGAcid();
            } else {
              formFields.value.Client_ID__c_contact = getGAcid();
            }
          }

          //Check if values being submitted are in the marketo form
          for (var y in formFields.value) {
            if (formFieldIDs.includes(y)) {
              // console.log("includes");

              //If so push to final fields array for submission
              finalFieldsArray.value[y] = formFields.value[y];
            } else {
              //If not, console log the id that does not exist in the form
              // console.log("form does not include " + y);
            }
          }

          if (currentFormId.value === "5646" && formAPIType.value === "marketo") {
            var numEmployeesVal = finalFieldsArray.value["numberOfEmployees"];

            if (numEmployeesVal.includes("-")) {
              numEmployeesVal = numEmployeesVal.split("-");
              finalFieldsArray.value["numberOfEmployees"] = parseInt(
                numEmployeesVal[0]
              );
            }

            if (numEmployeesVal.includes("+")) {
              numEmployeesVal = numEmployeesVal.split("+");
              finalFieldsArray.value["numberOfEmployees"] = parseInt(
                numEmployeesVal[0]
              );
            }
          }

          // console.log("removal check");
          // console.log(formFields.value);
          // console.log(finalFieldsArray.value);

          let mkLeadFormBody;
          switch (formAPIType.value) {
            case "hubspot":
              setPccShortTokenCookie("pcc_form_receipt", receiptToken.value);
              // Hubspot form object
              mkLeadFormBody = {
                submittedAt: +new Date(),
                fields: [],
                context: {
                  pageUri: window.location.href.split("?")[0],
                  pageName: "Vue Test Form",
                  hutk: getGTMCookie("hubspotutk"),
                  ipAddress: userIp.value,
                },
                legalConsentOptions: {
                  consent: {
                    // Include this object when GDPR options are enabled
                    consentToProcess: true,
                    text: "I agree to allow PointClickCare to store and process my personal data.",
                    communications: [
                      {
                        value: true,
                        subscriptionTypeId: 999,
                        text: "I agree to receive marketing communications from PointClickCare.",
                      },
                    ],
                  },
                },
              };

              hiddenValues.value["tracking_id"] = "G-L70H8MLGPL"; // A&P GA Measurement ID - NOT tracking ID
              hiddenValues.value["pcc_gcid"] = getGAcid() || "";
              hiddenValues.value["he_uid"] = hashHex || "";
              hiddenValues.value["sf_campaign_name"] = getGTMCookie("pccUTM") || getGTMCookie("pccCookie") || "";
              hiddenValues.value["pcc_utm"] = getGTMCookie("pccUTM") || getGTMCookie("pccCookie") || "";


              for (var i in formFields.value) {
                mkLeadFormBody.fields.push({
                  objectTypeId: "0-1", // "0-1" for contact items
                  name: i,
                  value: formFields.value[i] || "",
                });
              }

              // form.value.forEach((element) => {
              for (var hidden in hiddenValues.value) {
                // if (element.id === hidden) {
                mkLeadFormBody.fields.push({
                  objectTypeId: "0-1", // "0-1" for contact items
                  name: hidden,
                  value: hiddenValues.value[hidden] || "",
                });
                // }
              }
              // });

              break;

            case "marketo":
              // convert array into string with semi colons for format needed by Markerto database
              // console.log("formFields.value");
              // console.log(formFields.value);

              receiptToken.value = receiptToken.value.toUpperCase();
              setPccShortTokenCookie("pcc_form_receipt", receiptToken.value);
              // console.log("receiptToken: " + receiptToken.value);

              // console.log("MarketoProdCheck");
              // console.log(MarketoProdCheck.value);

              // create a form object in a format for Marketo's API.

              mkLeadFormBody = {
                // formId: 1003,
                formId: currentFormId.value,
                input: [
                  {
                    leadFormFields: {
                      ...finalFieldsArray.value,
                    },
                    visitorData: {
                      pageURL: window.location.href.split("?")[0],
                      queryString: window.location.search.substring(1),
                      // "leadClientIpAddress": "192.150.22.5",
                      userAgentString: navigator.userAgent,
                    },
                    cookie: getGTMCookie("_mkto_trk"),
                  },
                ],
              };

              // console.log("MKTO Form Body");
              // console.log(mkLeadFormBody);

              break;
          }

          if(formType.value==="marketo" && mkLeadFormBody.input[0].leadFormFields.numberOfEmployees) {
            mkLeadFormBody.input[0].leadFormFields.numberOfEmployees = parseInt(mkLeadFormBody.input[0].leadFormFields.numberOfEmployees)
          }
          
          submitData(mkLeadFormBody);
        } else {
          // console.log('captcha fail')
          recaptchaError.value = true;
        };
      };
    }

    onMounted(async () => {      
      if (formAPIType.value === "hubspot") {
        // Get IP address for HS analytics
        userIp.value = await getIpAddress();
      }      

      if (formAPIType.value === "hubspot" || marketoInstance.value === "aap") {
        // console.log('zoominfo setup: ' + marketoInstance.value)
        await zoomInfoSetup();   
      }

      if (isDemoModal.value !== "false") {
        await getFields();        
      }

      if(dlProduct.value && (formAPIType.value === 'marketo')) {
        if (
          window.location.hostname === "pcccorpdev.wpengine.com" ||
          window.location.hostname === "localhost"
        ) {          
          formFields.value["Products_of_Interest__c"] = dlProduct.value;
        } else {                            
          formFields.value["ProductsofInterest"] = dlProduct.value;
        }
      }

      if (!prefillToggleOff.value) {
        await prefillFields();

        if (
          sessionStorage.getItem("formFName") &&
          sessionStorage.getItem("formEmail") &&
          !singleLine.value
        ) {
          leadForm.value = true;
          leadFName.value = sessionStorage.getItem("formFName");
        }

        if(!sessionStorage.getItem("productInterest") && (formAPIType.value === 'marketo')) {
          leadForm.value = false;
        }
      }

      if(countryPrefill.value) {
        formFields.value["country"] = countryPrefill.value;
      }  
      
      if(productPrefill.value && (formAPIType.value === 'marketo')) {
        if (
          window.location.hostname === "pcccorpdev.wpengine.com" ||
          window.location.hostname === "localhost"
        ) {
          formFields.value["Products_of_Interest__c"] = productPrefill.value;
        } else {
          formFields.value["ProductsofInterest"] = productPrefill.value;
        }                        
      }  

      if (formAPIType.value === "hubspot") {
        visibilityConditionsCheckHubspot(form);

        if(!getGTMCookie("company")) {
          form.value.find((element) => element.id === 'company').required = true;
          form.value.find((element) => element.id === 'position_level').isHalfWidth = true;          
        }

        if(!getGTMCookie("zoominfo_state")) {
          form.value.find((element) => element.id === 'state').required = true;
        }
      }

      // console.log("onMounted");

      // Get a Captcha token on page mount

      // console.log(res);
    });

    onUpdated(() => {
      //Logic for snapping back to anchor element after form loads
      var anchorURL = false;

      if(window.location.href.includes("#")) {
        anchorURL = window.location.href.split('#').pop();               
      }      

      if (leadForm.value) {

        document.getElementById(anchorURL)?.scrollIntoView()
        return
      }

      if(formHeight.value === 0 && document.querySelector("mk-vue-form").offsetHeight != 0 && !modal.value && anchorURL) {
        formHeight.value = document.querySelector("mk-vue-form").offsetHeight;                
        var top = document.getElementById(anchorURL).offsetTop;

        window.scrollTo(0, top);                    
      }      
    })

    // Check if the modal has been opened, if so get the fields
    watch(isDemoModal, (isDemoModal, prevIsDemoModal) => {
      // console.log(`isDemoModal.value: ${isDemoModal.value}`);
      if (isDemoModal.value !== "false") {
        getFields();
      }
    });

    return {
      form,
      formFields,
      currentFormId,
      thankyouMesssage,
      onSubmit,
      wpdata,
      Loading,
      error,
      validationErrors,
      validateInput,
      pushCheckout,
      isSubmitting,
      recaptchaError,
      honeypotError,
      honeypotField,
      isSubmitted,
      toCamel,
      firstToLowerCase,
      noSpecialCharacters,
      getGAcid,
      setPccShortTokenCookie,
      setExtendedTimeCookie,
      getGTMCookie,
      pushDatalayer,
      showStateList,
      brand,
      category,
      formType,
      modal,
      gate,
      MarketoProdCheck,
      singleLine,
      receiptToken,
      isCaptchaValidated,
      cartCheck,
      checkoutCheck,
      queryString,
      urlParams,
      pccUTM,
      pccUTMStripped,
      checkCountry,
      isDoubleColumn,
      user_hash,
      formAPIType,
      isDemoModal,
      leadForm,
      leadFName,
      notYouFormSwitch,
      finalFieldsArray,
      fieldConditions,
      visibilityConditionsCheck,
      visibilityConditionsCheckHubspot,
      countryPrefill,
      contentType,
      marketoInstance,
      thankyouUrl
    };
  },
};

export default appComponent;
</script>
<template>
  <h4 v-if="leadForm" class="mb-4 text-center">
    <strong>Welcome Back {{ leadFName }}</strong>
  </h4>

  <div class="">
    <!-- fetch form {{form}} -->
    <!-- Form: {{ currentFormId }} <br /><br /> -->

    <form
      @submit.prevent="onSubmit"
      v-if="form"
      :class="{
        'single-line-form': singleLine,
        'd-none': (isSubmitted && !thankyouUrl) || recaptchaError || honeypotError,
        'double-column': isDoubleColumn,
      }"
    >
      <div class="form-container">        
        <div
          v-for="field in form"
          :key="field.id"
          class="form-floating"
          :class="[
            ((!leadForm || (leadForm && (field.id === 'Products_of_Interest__c' || field.id === 'ProductsofInterest'))) &&
            field.dataType === 'hidden' || (leadForm && (field.id != 'Products_of_Interest__c' && field.id != 'ProductsofInterest')) || !field.conditionalShow)
              ? 'field-hidden'
              : 'field-visible',
            field.isHalfWidth ? 'half-width' : 'full-width',
            field.dataType.toLowerCase() === 'textarea'
              ? 'textarea-container'
              : '',
              ((field.id === 'Products_of_Interest__c' || field.id === 'ProductsofInterest') && contentType === 'Solution') ? 'hidden' :''
          ]"
        >
          <!-- Text field -->
          <input
            v-if="
              field.id &&
              field.dataType === 'text' &&
              !leadForm &&              
              field.conditionalShow
            "
            v-model="formFields[field.id]"
            @keyup="validateInput(field.id)"
            @blur="validateInput(field.id)"
            @paste="validateInput(field.id)"
            @focus="pushCheckout(field.id)"
            class="block visible-field"
            :field="field.id"
            :name="field.id"
            :aria-label="field.label"
            placeholder=" "
          />

          <!-- Text area -->
          <textarea
            v-if="
              field.id &&
              field.dataType.toLowerCase() === 'textarea' &&
              !leadForm &&
              field.conditionalShow
            "
            @keyup="validateInput(field.id)"
            @blur="validateInput(field.id)"
            @paste="validateInput(field.id)"
            v-model="formFields[field.id]"
            class="block visible-field"
            :field="field.id"
            :name="field.id"
            placeholder=" "
            :aria-label="field.label"
          ></textarea>

          <!-- Email -->
          <input
            v-if="
              field.id &&
              field.dataType === 'email' &&
              !leadForm &&
              field.conditionalShow
            "
            v-model="formFields[field.id]"
            @keyup="validateInput(field.id)"
            @blur="validateInput(field.id)"
            @paste="validateInput(field.id)"
            @focus="pushCheckout(field.id)"
            type="email"
            class="block visible-field"
            :placeholder="' '"
            :field="field.id"
            :name="field.id"
            :aria-label="field.label"
          />

          <!-- Phone -->
          <input
            v-model="formFields[field.id]"
            v-if="
              field.id &&
              field.dataType === 'telephone' &&
              !leadForm &&
              field.conditionalShow
            "
            @keyup="validateInput(field.id)"
            @blur="validateInput(field.id)"
            @paste="validateInput(field.id)"
            type="tel"
            name="formFields[field.id]"
            class="block visible-field"
            placeholder=" "
            :field="field.id"
            :aria-label="field.label"
          />

          <!-- Number Input -->
          <input
            v-if="
              field.id &&
              field.dataType === 'number' &&
              !leadForm &&
              field.conditionalShow
            "
            v-model="formFields[field.id]"
            @keyup="validateInput(field.id)"
            @blur="validateInput(field.id)"
            @paste="validateInput(field.id)"
            type="number"
            class="block visible-field"
            placeholder=" "
            :field="field.id"
            :name="field.id"
            :aria-label="field.label"
          />

          <!-- URL Input -->
          <input
            v-if="
              field.id &&
              field.dataType === 'url' &&
              !leadForm &&
              field.conditionalShow
            "
            v-model="formFields[field.id]"
            @keyup="validateInput(field.id)"
            @blur="validateInput(field.id)"
            @paste="validateInput(field.id)"
            type="url"
            class="block visible-field"
            placeholder=" "
            :field="field.id"
            :name="field.id"
            :aria-label="field.label"
          />

          <!-- Checkbox Input -->
          <div
            class="d-block"
            v-if="
              field.id &&
              field.dataType === 'checkbox' &&
              (field.id !== 'Express_Consent__c' &&
                field.id !== 'express_consent_checkbox' &&
                field.id !== 'expressConsentCheckbox') &&
              !leadForm &&
              field.conditionalShow
            "
          >
            <input              
              v-model="formFields[field.id]"
              @keyup="validateInput(field.id)"
              @blur="validateInput(field.id)"
              @paste="validateInput(field.id)"
              type="checkbox"
              class="form-check-input mx-2 visible-field"
              placeholder=" "
              :field="field.id"
              :name="field.id"
              :aria-label="field.label"
            />

            <label
              class="consent-label form-check-label d-inline"
              v-if="!leadForm && field.conditionalShow"              
              :for="field.id"              
            >
              {{field.label}}
            </label>
          </div>

          <!-- Validation message -->
          <transition name="fade" mode="out-in">
            <div
              class="error form-error border"
              v-if="validationErrors[field.id] && field.validationMessage"
              v-html="field.validationMessage"
            ></div>
          </transition>

          <!-- if Canada selected: show consent checkbox  -->
          <!-- if the form ID is 1206 or 5783 or 5794 (Marketo Senior Care Event Lead Form), display the consent checkbox regardless of country -->
          <div
            class="d-block"
            v-if="
              (formFields['country'] === 'Canada' ||
                ['5794', '5783', '1206'].includes(currentFormId)) &&
              !leadForm &&
              (field.id === 'Express_Consent__c' ||
                field.id === 'expressConsentCheckbox')
            "
          >
            <input
              @change="validateInput(field.id)"
              type="checkbox"
              class="form-check-input mx-2 visible-field"
              id="expressConsentCheckbox"
              v-model="formFields[field.id]"
              v-if="!leadForm && field.conditionalShow"
              :field="field.id"
              :name="field.id"
              :aria-label="field.label"
            />
            <label
              class="consent-label form-check-label d-inline"
              v-if="!leadForm && field.conditionalShow"
              :name="field.id"
              for="expressConsentCheckbox"
              >I agree to receive updates from PointClickCare. I understand that
              I can opt out at any time. For more details, please refer to our
              <a
                href="//pointclickcare.com/website-privacy-policy/"
                target="_blank"
                title="Privacy Policy - PointClickCare"
                id=""
                >Privacy Policy</a
              >
              or
              <a
                href="mailto:success@pointclickcare.com"
                target="_blank"
                title="Contact PointClickCare"
                id=""
                >contact us</a
              >.</label
            >
          </div>

          <!--  Lab consent box  -->
          <div
            class="d-block"
            v-if="
              ['express_consent_checkbox', 'labConsentCheckbox'].includes(
                field.id
              )
            "
          >
            <input
              @change="validateInput(field.id)"
              type="checkbox"
              class="form-check-input mx-2 visible-field"
              id="labConsentCheckbox"
              v-model="formFields[field.id]"
              v-if="
                field.id &&
                field.dataType === 'checkbox' &&
                ['express_consent_checkbox', 'labConsentCheckbox'].includes(
                  field.id
                ) &&
                !leadForm &&
                field.conditionalShow
              "
              :name="field.id"
              :field="field.id"
              :aria-label="field.label"
            />
            <label
              class="consent-label form-check-label d-inline"
              v-if="
                ['express_consent_checkbox', 'labConsentCheckbox'].includes(
                  field.id
                ) &&
                !leadForm &&
                field.conditionalShow
              "
              for="labConsentCheckbox"
              ><span>*</span> {{ field.label }}
            </label>
          </div>
          <!-- Select group -->
          <div
            class="dynamic-input form-group"
            role="group"
            v-if="
              field.fieldMetaData &&
              field.dataType === 'select' &&
              field.conditionalShow
            "
          >
            <!-- Select (other than State field) -->
            <select
              @change="validateInput(field.id)"
              v-model="formFields[field.id]"
              v-if="
                (marketoInstance === 'aap' &&
                !field.fieldMetaData.multiSelect &&
                field.fieldMetaData &&
                field.dataType === 'select' &&
                field.id === 'state') ||
                !field.fieldMetaData.multiSelect &&
                field.fieldMetaData &&
                field.dataType === 'select' &&
                field.id !== 'state' &&
                field.id !== 'state_province__mkto_' &&
                (!leadForm || (leadForm && (field.id === 'Products_of_Interest__c' || field.id === 'ProductsofInterest'))) &&                
                field.conditionalShow
              "
              name="formFields[field.id]"
              class="block visible-field"
              :field="field.id"
              :aria-label="field.label"
            >
              <!-- Select dropdown options -->
              <template
                v-for="(item, index) in field.fieldMetaData.values"
                :key="index"
              >
                <option v-if="index != 0" v-bind:value="item.value">
                  {{ item.label }}
                </option>
                <option v-else v-bind:value="item.value" selected>
                  {{ item.label }}
                </option>
              </template>
            </select>

            <!-- State Select -->
            <select
              @change="validateInput(field.id)"
              v-model="formFields[field.id]"
              v-if="
                marketoInstance != 'aap' &&
                !field.fieldMetaData.multiSelect &&
                field.fieldMetaData &&
                field.dataType === 'select' &&
                (field.id === 'state' ||
                  field.id === 'state_province__mkto_') &&
                ([formFields['country'], formFields['country_select']].includes(
                  'United States'
                ) ||
                  [
                    formFields['country'],
                    formFields['country_select'],
                  ].includes('Canada') ||
                  (!formFields['country'] && !formFields['country_select'])) &&
                !leadForm &&                
                field.conditionalShow
              "
              name="formFields[field.id]"
              class="block visible-field"
              :field="field.id"
              :aria-label="field.label"
            >
              <!-- Select dropdown options -->
              <template
                v-for="(item, index) in field.fieldMetaData.values"
                :key="index"
              >
                <!-- Hubspot state (US Only) options -->
                <option
                  v-if="formAPIType === 'hubspot' && field.id === 'state'"
                  v-bind:value="item.value"
                >
                  {{ item.label }}
                </option>
                <!-- Canada state options -->
                <option
                  v-if="
                    [
                      formFields['country'],
                      formFields['country_select'],
                    ].includes('Canada') && checkCountry('Canada', index)
                  "
                  v-bind:value="item.value"
                >
                  {{ item.label }}
                </option>
                <!-- US state options -->
                <option
                  v-if="
                    ((formFields['country'] === 'United States' ||
                      formFields['country_select'] === 'United States') &&
                      formAPIType === 'hubspot' &&
                      checkCountry('United States', index) &&
                      field.id !== 'state') ||
                    (formAPIType === 'marketo' &&
                      field.id === 'state' &&
                      formFields['country'] === 'United States' &&
                      checkCountry('United States', index))
                  "
                  v-bind:value="item.value"
                >
                  {{ item.label }}
                </option>
                <!-- "Other" option - always show -->
                <option
                  v-if="checkCountry('Other', index)"
                  v-bind:value="item.value"
                >
                  {{ item.label }}
                </option>
              </template>
            </select>

            <!-- Multiselect -->
            <select
              @change="validateInput(field.id)"
              v-model="formFields[field.id]"
              v-if="
                field.fieldMetaData.multiSelect &&
                !leadForm &&
                field.conditionalShow
              "
              multiple
              name="formFields[field.id]"
              class="block visible-field"
              :field="field.id"
              :aria-label="field.label"
            >
              <option
                v-for="(item, index) in field.fieldMetaData.values"
                :key="index"
                v-bind:value="item.value"
              >
                {{ item.label }}
              </option>
            </select>

            <i class="chevron" role="presentation"></i>
          </div>

          <!-- Checkboxes -->
          <div
            class="checkboxes-container form-group"
            role="group"
            v-if="field.fieldMetaData && field.dataType === 'checkboxes'"
          >
            <div
              class="ind-checkbox-container"
              v-for="(item, index) in field.fieldMetaData.values"
              :key="index"
            >
              <input
                type="checkbox"
                class="form-check-input multi-check-input mx-2"
                :checkboxes="field.id"
                :id="item.value"
                v-bind:value="item.value"
                @change="validateInput(field.id)"
                :name="field.id"
                :aria-label="field.label"
              />

              <!-- Checkbox label -->
              <label class="checkbox-label" :for="item.value">
                {{ item.label }}
              </label>
            </div>
          </div>

          <!-- Hidden fields -->
          <input
            v-if="field.id && field.dataType === 'hidden'"
            v-model="formFields[field.id]"
            type="hidden"
            aria-hidden="true"
          />

          <!-- Label -->
          <label
            class="floating-label"
            for="{{formFields[field.id]}}"
            v-if="
              field.label &&
              field.dataType !== 'hidden' &&
              field.id !== 'Express_Consent__c' &&
              field.id !== 'expressConsentCheckbox' &&
              field.dataType !== 'checkbox' &&
              !['express_consent_checkbox', 'labConsentCheckbox'].includes(
                field.id
              ) &&
              (!leadForm || (leadForm && (field.id === 'Products_of_Interest__c' || field.id === 'ProductsofInterest'))) &&                
              field.conditionalShow
            "
          >
            <span class="required" v-if="field.required">* </span>
            <!-- {{ field.label.slice(0, -1) }} -->
            {{ field.label }}
          </label>
        </div>

        <div class="not-you-link-container text-center mb-4">
          <a
            v-if="leadForm"
            class="font-weight-normal not-you-link"
            @click="notYouFormSwitch()"
            style="cursor: pointer"
            >Not you? Click here to update your info.</a
          >
        </div>
      </div>

      <!-- Honeypot field - hidden from users -->
      <input
        v-model="honeypotField"
        type="text"
        name="website"
        style="position: absolute; left: -9999px; opacity: 0; pointer-events: none;"
        tabindex="-1"
        autocomplete="off"
        aria-hidden="true"
      />

      <div v-for="(item, index) in validationErrors" :key="index">
        - {{ index }} - {{ item }}
      </div>
      <!--
      <div v-if="Loading" class="my-5">
        <b>Submitting form...</b>
      </div>
      -->

      <button
        type="submit"
        class="my-3 btn-submit btn-cta btn-cta-green px-5 py-3 btn-form"
        :disabled="(!isSubmitting || Loading) && !leadForm"
      >
        {{ Loading ? "Please Wait" : "Submit" }}
      </button>
      <div class="break"></div>
      <div class="captcha-message">
        This site is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </div>
    </form>

    <div
      v-if="isSubmitted && thankyouMesssage"
      class="font-weight-bold text-center"
    >
      {{ thankyouMesssage }}
    </div>

    <div
      v-if="recaptchaError"
      class="font-weight-bold text-center"
    >
      There has been a ReCaptcha error, please refresh the page and try again
    </div>

    <div
      v-if="honeypotError"
      class="font-weight-bold text-center text-danger"
    >
      Invalid form submission detected. Please try submitting again.
    </div>
    <!-- <span :v-html="thankyouMesssage"></span> -->

    <!-- Result JSON output -->
    <!-- 
      <div v-if="!Loading && wpdata" class="mt-5">
        <pre><b>Result: {{ wpdata }}</b></pre>
      </div>
    -->
  </div>
</template>

